module.exports = __webpack_public_path__ + "static/media/hoan_tien_4.0bd18494.png";